
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csboard/library",
      function () {
        return require("private-next-pages/csboard/library/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csboard/library"])
      });
    }
  